<script>
    import { isMobile } from "@/utils";
    import StoreShop from "@/components/store/StoreShop";
    import MobileTabs from "@/components/MobileTabs";

    export default {
        name: "StoreShops",
        components: { MobileTabs, StoreShop },
        props: {
            sliderOptions: Object,
            slidesCount: Object,
            icon: String,
            buttonSize: {
                type: String,
                default: "md",
            },
        },
        data() {
            return {
                selectedTabIndex: 0,
                newCities: {
                    "#msk": {
                        index: 0,
                        code: "msk",
                        name: "Москва",
                    },
                    "#spb": {
                        index: 1,
                        code: "spb",
                        name: "Санкт-Петербург",
                    },
                },
            };
        },
        computed: {
            cityName() {
                return Object.values(this.newCities).find(
                    (city) => city.index === this.selectedTabIndex
                ).name;
            },
            tabOffsetCompute() {
                return 100 * this.selectedTabIndex + "%";
            },
            shops() {
                return [
                    {
                        type: "msk",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A41a367aae849d125ee93d28a232574e4bf694adc968f2e2a9cf6530b2ed43725&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "Бутырский Вал, 32",
                        phone: "+7 495 646-10-96",
                        routes: [
                            { title: "Маршрут от Новослободской", url: "/5/" },
                            { title: "Маршрут от Белорусской", url: "/4/" },
                        ],
                        slides: this.slidesCount.msk,
                    },
                    {
                        type: "spb",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac6f9b787eeebe5ed6ea9c25a7ccad2e52657b10554778a34a65a58403f0a825d&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "Лиговский проспект, 3/9",
                        phone: "+7 812 407-35-98",
                        routes: [{ title: "Маршрут от Площади Восстания", url: "/7/" }],
                        slides: this.slidesCount.spb,
                    },
                ];
            },
        },
        mounted() {
            if (this.$route.hash) {
                this.selectedTabIndex = this.newCities[this.$route.hash]?.index || 0;
            }
        },
        methods: {
            onChangeTab(index) {
                this.selectedTabIndex = index;
                if (!isMobile(992)) {
                    location.hash = Object.values(this.newCities)[index].code;
                }
            },
        },
    };
</script>

<template>
    <div class="store-shops js-store-shops">
        <div class="store-shops__tabs">
            <div class="store-shops__controls">
                <span
                    class="store-shops__controls-progress"
                    :style="{ transform: `translateX(${tabOffsetCompute})` }"
                ></span>
                <button
                    v-for="city in Object.values(newCities)"
                    class="store-shops__trigger outline"
                    :class="{ selected: selectedTabIndex === city.index }"
                    :key="city.index"
                    @click="onChangeTab(city.index)"
                >
                    {{ city.name }}
                </button>
            </div>

            <div class="store-shops__mobile desktop-hidden">
                <mobile-tabs :max-length="shops.length" @on-change="onChangeTab">
                    <div class="store-shops__city">
                        {{ cityName }}
                    </div>
                </mobile-tabs>
            </div>

            <div class="store-shops__content">
                <div class="store-shops__tab">
                    <store-shop
                        :id="selectedTabIndex"
                        :shop="shops[selectedTabIndex]"
                        :slider-options="sliderOptions"
                        :icon="icon"
                        :button-size="buttonSize"
                    ></store-shop>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .store-shops {
        padding-top: 16px;
        @include bp($bp-desktop-sm) {
            padding-top: 32px;
        }
    }

    .store-shops__tabs {
        margin-bottom: 20px;
        border: var(--new-store-content-border);
        border-color: var(--new-store-content-border-color);
        border-radius: var(--new-store-content-radius);
        box-shadow: var(--new-store-content-shadow);
        @include bp($bp-desktop-sm) {
            border: none;
            box-shadow: none;
        }
    }

    .store-shops__controls {
        display: none;
        @include bp($bp-desktop-sm) {
            position: relative;
            display: flex;
            margin-bottom: 16px;
            background-color: var(--new-store-button-fill);
            border-radius: var(--new-store-button-radius);
            overflow: hidden;
        }
    }

    .store-shops__controls-progress {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 50%;
        background: var(--new-store-button-fill--selected);
        border-radius: inherit;
        pointer-events: none;
        transition: transform 0.2s ease-in;
    }

    .store-shops__mobile {
        padding: 16px 8px 0;
    }

    .store-shops__city {
        color: var(--new-store-city-title-color--mobile);
        font-family: var(--new-store-button-font);
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        text-transform: var(--new-store-button-case);
    }

    .store-shops__trigger {
        @include bp($bp-desktop-sm) {
            position: relative;
            z-index: 2;
            flex-basis: 50%;
            max-width: 50%;
            padding: 20px 15px 18px;
            font-family: var(--new-store-button-font);
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            text-transform: var(--new-store-button-case);
            border-radius: var(--new-store-button-radius);
            transition: color 0.2s ease-in;
            &:hover:not(.selected) {
                color: var(--new-store-button-color--hover);
            }
            &.selected {
                color: var(--new-store-button-color--active);
            }
        }
        @include bp($bp-desktop-lg) {
            padding: 30px 15px 28px;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .store-shops__content {
        padding: 16px 12px 12px;
        border: none;
        border-radius: var(--new-store-content-radius);
        box-shadow: none;
        @include bp($bp-desktop-sm) {
            padding: 40px 40px 72px;
            border: var(--new-store-content-border);
            box-shadow: var(--new-store-content-shadow);
        }
    }
</style>
